setInterval(function () {
  $(".js-drawer-open .cv_index_coll")
    .not(".slick-initialized")
    .slick({
      infinite: false,
      arrows: true,
      swipe: false,
      draggable: false,
      variableWidth: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            swipe: true,
            draggable: true,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            swipe: true,
            draggable: true,
            slidesToScroll: 2,
          },
        },
      ],
    });
}, 1000);
$(document).ready(function () {});
